var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$isWeb)?_c('i',{class:['iconfont', 'icon-' + _vm.name, _vm.svgClass],style:({ color: _vm.color, fontSize: _vm.width, lineHeight: _vm.height, bold: true })}):_c('view',{class:['iconfont', 'icon-' + _vm.name, _vm.svgClass],style:({ color: _vm.color, fontSize: _vm.width, lineHeight: _vm.height, bold: true })})
}
var staticRenderFns = []

export { render, staticRenderFns }